import { render, staticRenderFns } from "./shareModal.vue?vue&type=template&id=0121d2c8&scoped=true"
import script from "./shareModal.vue?vue&type=script&lang=js"
export * from "./shareModal.vue?vue&type=script&lang=js"
import style0 from "./shareModal.vue?vue&type=style&index=0&id=0121d2c8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0121d2c8",
  null
  
)

export default component.exports